import { Component, OnInit } from '@angular/core'
import { ModalController } from '@ionic/angular/standalone'
import { CacheService } from '../services/business/cache.service'
import { CRBSettingKeys } from '../services/api/models/configuration.model'
import { PhonePipe } from '../directives/phone.pipe'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss'],
})
export class ContactUsComponent implements OnInit {

    phoneNumber = ''

    contactUsTitleText = ''
    contactUsText: SafeHtml = ''

    constructor(
        private modalController: ModalController,
        private cacheService: CacheService,
        private phonePipe: PhonePipe,
        private domSanitizer: DomSanitizer
    ) {
    }

    ngOnInit(): void {

        this.contactUsTitleText = this.cacheService.brandSetting(CRBSettingKeys.ContactUsTitleText)

        const phoneNumber = this.cacheService.brandSetting(CRBSettingKeys.BankSupportPhoneNumber)
        const contactUsText = this.cacheService.brandSetting(CRBSettingKeys.ContactUsText)

        this.contactUsText = this.domSanitizer.bypassSecurityTrustHtml(
            contactUsText?.replace('{{phoneNumber}}', this.phonePipe.transform(phoneNumber || '')) || '')
    }

    public async dismissModal(): Promise<void> {
        await this.modalController.dismiss()
    }
}
